import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const HR = styled.hr`
  height: 2px;
  border: 0;
  margin: 20px auto;
  width: ${({ isWide }) => (isWide ? "100%" : "20%")};
  color: ${({ $color }) => `var(--color-${$color}, var(--color-black))`};
  background-color: ${({ $backgroundColor }) =>
    `var(--color-${$backgroundColor}, var(--color-black))`};

  &.is-style-dots {
    height: unset;
    width: 100%;
    display: flex;
    justify-content: center;
    background-color: transparent;
    letter-spacing: 1rem;
    padding-left: 1rem;
    margin: 0;

    &:before {
      content: "· · ·";
      font-size: 40px;
      font-family: Garamond, sans-serif;
      width: 100%;
      display: block;
      text-align: center;
      color: ${({ $color }) => `var(--color-${$color}, var(--color-black))`};
    }
  }
`;

const Separator = ({ className, $color, $backgroundColor, isWide }) => {
  return (
    <HR
      className={className}
      $color={$color}
      $backgroundColor={$backgroundColor}
      isWide={isWide}
    />
  );
};

Separator.propTypes = {
  className: PropTypes.string,
  $color: PropTypes.string,
  $backgroundColor: PropTypes.string,
  isWide: PropTypes.bool,
};

Separator.defaultProps = {
  className: "is-style-default",
  $color: "black",
  $backgroundColor: "white",
  isWide: false,
};

export default Separator;
